import React from 'react';
import { connect } from 'react-redux';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { hasMinimumLength } from '@/utils/resultsHelper';
import DropdownItem from '@/components/DropdownItem';
import StandardToolsMenu from '@/components/tools/StandardToolsMenu';
import { confirmSearchDeletion, showSaveSearch } from '../actions';
import { showShareSearch } from '../sharing/actions';
import { searchPermissions } from '../constants';
import { encodeQuery } from '../searchHelper';

const SearchTools = ({
  category,
  search,
  url,
  allowRead,
  allowCreate,
  allowUpdate,
  allowDelete,
  allowShare,
  allowSecure,
  showDelete,
  duplicateSearch,
  saveSearch,
  share,
  upward,
  listItem = false,
}) => (
  <StandardToolsMenu
    allowRead={allowRead}
    allowDelete={allowDelete}
    href={url}
    listItem={listItem}
    onDelete={() => showDelete(category, search.code)}
    upward={upward}
  >
    {allowUpdate && (
    <DropdownItem icon="edit" textId="actions.rename" onClick={() => saveSearch(category, search.code)} />
    )}
    {allowCreate && (
    <DropdownItem icon="clone" textId="actions.duplicate" onClick={() => duplicateSearch(category, search.code)} />
    )}
    {(allowShare || allowSecure) && (
    <DropdownItem
      icon={(allowSecure && !allowShare) ? 'shield' : 'share alternate'}
      textId={(allowSecure && !allowShare) ? 'actions.security' : 'actions.share'}
      onClick={() => share(category, search.code)}
    />
    )}
    <CopyToClipboard text={`${encodeQuery(search.query, search.filter)}`}>
      <DropdownItem icon="copy outline" textId="actions.copy.url" disabled={!hasMinimumLength(search.query)} />
    </CopyToClipboard>
  </StandardToolsMenu>
);

const mapStateToProps = ({
  auth: { role: { permissions } },
}, { search }) => (
  {
    allowRead: permissions.search.read,
    allowCreate: permissions.search.create,
    allowUpdate: permissions.search.update && search.permissions[searchPermissions.UPDATE],
    allowDelete: permissions.search.destroy && search.permissions[searchPermissions.DESTROY],
    allowSecure: permissions.search.secure && search.permissions[searchPermissions.SECURITY],
    allowShare: permissions.search.share && (search.permissions[searchPermissions.INVITE_MEMBER]
          || search.permissions[searchPermissions.REMOVE_MEMBER]),
  }
);

const mapDispatchToProps = {
  showDelete: confirmSearchDeletion,
  duplicateSearch: (category, code) => showSaveSearch(category, code, true),
  saveSearch: (category, code) => showSaveSearch(category, code, false),
  share: showShareSearch,
};

export default connect(mapStateToProps, mapDispatchToProps)(SearchTools);
